"use strict";
'use client';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = require("react");
var _AuthContext = _interopRequireDefault(require("../AuthContext"));
var _errors = require("../errors");
var _utils = require("../utils/utils");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function useAuthUser() {
  var context = (0, _react.useContext)(_AuthContext.default);
  if (context === null) {
    throw new _errors.AuthError('Auth Provider is missing. ' + 'Make sure, you are using this hook inside the auth provider.');
  }
  if ((0, _utils.isAuthenticated)(context.value)) {
    return context.value.userState;
  } else {
    return null;
  }
}
var _default = exports.default = useAuthUser;